import type { ReactNode } from 'react'
import DelayedLoader from './DelayedLoader'
import Loader from './Loader'

export type LoaderProps = Readonly<{
  loading: boolean
  children: ReactNode
  height?: number
  rows?: number
  delay?: number
}>

export default function WithLoader(props: LoaderProps) {
  return props.delay ? <DelayedLoader {...props} /> : <Loader {...props} />
}
